import React, { useMemo } from 'react';
import { axisTooltipFormatter } from '@common/utils/chartTooltipFormatter';
import { truncateLabel } from '@common/utils/chartUtils';
import ChartWidgetContainer from '@common/components/ChartWidgetContainer';

function GroupedBarChartWidget({ widget }) {
  const { data } = widget;

  const option = useMemo(() => {
    if (!data) return null;

    const isMultiSeries = data.series && Array.isArray(data.series);

    return {
      tooltip: {
        trigger: 'axis',
        confine: true,
        appendToBody: true,
        axisPointer: {
          type: 'shadow',
        },
        formatter: axisTooltipFormatter,
      },
      legend: isMultiSeries
        ? {
            data: data.series.map((s) => s.name),
            textStyle: {
              fontSize: 11,
            },
            formatter: (name) => truncateLabel(name),
            tooltip: {
              show: true,
              formatter: (params) => params.name,
            },
            type: 'scroll',
            bottom: 0,
          }
        : undefined,
      grid: {
        left: '3%',
        right: '4%',
        bottom: isMultiSeries ? '15%' : '3%',
        containLabel: true,
      },
      xAxis: {
        type: 'category',
        data: data.categories || [],
        axisLabel: {
          fontSize: 11,
          rotate: data.categories && data.categories.some((cat) => String(cat).length > 10) ? 45 : 0,
          formatter: (value) => truncateLabel(value),
        },
        tooltip: {
          show: true,
          formatter: (params) => params.value,
        },
      },
      yAxis: {
        type: 'value',
        axisLabel: {
          fontSize: 11,
        },
      },
      series: isMultiSeries
        ? data.series.map((series, index) => ({
            name: series.name,
            type: 'bar',
            data: series.data,
            label: {
              show: true,
              position: 'top',
              fontSize: 10,
            },
            itemStyle: {
              color: series.color || `hsl(${index * 60}, 70%, 50%)`,
            },
          }))
        : [
            {
              name: widget.title,
              type: 'bar',
              data: data.categoryColors
                ? (data.values || []).map((v, i) => {
                    const catColor = data.categoryColors[i];
                    return catColor ? { value: v, itemStyle: { color: catColor } } : v;
                  })
                : data.values || [],
              itemStyle: {
                color: data.color || '#3498db',
              },
            },
          ],
    };
  }, [data, widget.title]);

  return <ChartWidgetContainer widget={widget} option={option} />;
}

export default GroupedBarChartWidget;
